module.exports = __webpack_public_path__ + "img/ErrorStateIcon.8ead592.svg";